import React from "react";

const VideoEmbed = ({ src, title = "Video" }) => (
  <div className="relative w-full aspect-video rounded-ku-lg overflow-hidden shadow-elevated bg-ku-soft">
    <iframe
      src={src}
      title={title}
      className="absolute inset-0 w-full h-full"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
);

export default VideoEmbed;
